import ReactDOM from 'react-dom';
// Polyfill findDOMNode to avoid errors in React 18+
;(ReactDOM as any).findDOMNode = function () {
  return null;
};
